import prepareComponent from "@bluframe/grapple/prepareComponent"
import useToggle from "@bluframe/grapple/useToggle"
import pick from "ramda/src/pick"
import { memo } from "react"

import Detail from "./Detail"

interface Props {
  isExpandable?: boolean
  isMarkdown?: boolean
  label: string
  text: string
}

export interface ComponentProps extends Omit<Props, "text"> {
  isExpanded: boolean
  items: string[]
  onToggleIsExpanded: () => void
}

const useComponentProps = (props: Props): ComponentProps => {
  const [isExpanded, toggleExpanded] = useToggle()

  const onToggleIsExpanded = (): void => {
    toggleExpanded()
  }

  return {
    ...pick(["isExpandable", "isMarkdown", "label"])(props),
    isExpanded,

    items: props.isMarkdown ? [props.text] : props.text.split(", "),
    onToggleIsExpanded
  }
}

export default prepareComponent<Props, ComponentProps>(useComponentProps)(
  memo(Detail)
)
